import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { createRealtimeClient } from '../lib/realtimeClient';

/**
 * Conecta ao WebSocket da escola e invalida queries do dashboard
 * quando chega `dashboard.invalidate` (portaria / chamada / presença).
 */
export function useEscolaDashboardRealtime(escolaId?: string | null) {
  const queryClient = useQueryClient();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!escolaId) {
      setConnected(false);
      return;
    }

    let active = true;
    const client = createRealtimeClient({
      onOpen: () => {
        if (active) setConnected(true);
      },
      onClose: () => {
        if (active) setConnected(false);
      },
      onError: () => {
        if (active) setConnected(false);
      },
      onEvent: (event) => {
        if (event.type !== 'dashboard.invalidate') return;
        const payload = (event.payload ?? {}) as {
          escolaId?: string;
          reasons?: string[];
        };
        if (payload.escolaId && payload.escolaId !== escolaId) return;

        void queryClient.invalidateQueries({ queryKey: ['dashboard-escola'] });
        void queryClient.invalidateQueries({ queryKey: ['presencas-diarias'] });
        void queryClient.invalidateQueries({ queryKey: ['eventos-acesso'] });
        // Turno ao vivo / Governança (grade × status-dia)
        void queryClient.invalidateQueries({ queryKey: ['chamadas'] });
        void queryClient.invalidateQueries({ queryKey: ['chamadas-status-dia'] });
        void queryClient.invalidateQueries({ queryKey: ['chamadas-gestao-status'] });
        void queryClient.invalidateQueries({ queryKey: ['turno-ao-vivo-horarios'] });
        void queryClient.invalidateQueries({ queryKey: ['horarios-gestao'] });
      },
    });

    return () => {
      active = false;
      setConnected(false);
      client.close();
    };
  }, [escolaId, queryClient]);

  return { connected };
}
